<template>
  <div
    class="filtering-facets"
    :class="rootCssClass"
  >
    <div
      ref="filteringFacetsGrid"
      class="grid-x grid-margin-x"
    >
      <div
        :class="['cell small-12 medium-12', { 'facets-list-pending': isProductsLoading && isDynamicFilters }]"
      >
        <FacetsList />
      </div>
    </div>

    <SortAndFilter />
  </div>
</template>

<script setup>
import useFilteringFacets from '../composables/useFilteringFacets';
import FacetsList from './FacetsList';
import SortAndFilter from './SortAndFilter';

const props = defineProps({
  facets: {
    type: Array,
    required: true,
  },
  sortBy: {
    type: Array,
    required: true,
  },
  customFacetTypes: {
    /*
      Use this prop to set custom renderers for custom facet types.
      All avaialable facets are listed in /src/components/criteria/facetTypes.js
      Example:
      {
        CustomFacet1Name: 'MultiSelectRange',
        CustomFacet2Type: 'MULTISELECTSWATCH',
        default: 'MultiSelectDefault',
      }
    */
    type: Object,
    default: () => ({}),
  },
  displayModes: {
    type: Object,
    default: () => ({
      mobile: 'slideout',
      desktop: 'dropdown',
      tablet: 'slideout',
    }),
  },
  showFacetSelectedValuesList: {
    type: Boolean,
    default: false,
  },
  maxCustomRangeValueLength: {
    type: Number,
    default: 4,
  },
  prioritizedFacets: {
    type: Array,
    default: () => [],
  },
  drawerOptions: {
    type: Object,
    default: () => ({}),
  },
  slideoutFacets: {
    type: Object,
    default: () => null,
  },
  maxDesktopFilters: {
    type: Number,
    default: 0,
  },
  maxTabletFiltersNumber: {
    type: Number,
    default: 0,
  },
  productCount: {
    type: Number,
    default: 0,
  },
  totalFacetSelectedCount: {
    type: Number,
    default: 0,
  },
  doDynamicFacetCounterUpdateSlideout: {
    type: Boolean,
    default: false,
  },
  mySizesData: {
    type: Object,
    default: () => ({}),
  },
  disableDeliveryAndFulfillmentFacet: {
    type: Boolean,
    default: false,
  },
  consumerStore: {
    type: Object,
    default: () => ({}),
  },
  pageType: {
    type: String,
    default: 'registry',
  },
  xapiExperimentIds: {
    type: Array,
    default: () => ([]),
  },
  deviceInfo: {
    type: Object,
    default: () => ({}),
  },
  isSYS: {
    type: Boolean,
    default: false,
  },
  isDynamicFilters: {
    type: Boolean,
    default: false,
  },
  isProductsLoading: {
    type: Boolean,
  },
});

const emit = defineEmits([
  'selectedCriteria',
  'selectedOptions',
  'saveMySizesToggle',
]);

const { filteringFacetsGrid, rootCssClass } = useFilteringFacets(props, emit);
</script>

<style lang="scss">
// import without scoped on purpose
// Styles are moved to the critical section to avoid FOUC (flash of unstyled content)
</style>

<style lang="scss" brand="mcom" scoped>
// Styles are moved to the critical section to avoid FOUC (flash of unstyled content)
</style>
<style lang="scss" brand="bcom" scoped>
// Styles are moved to the critical section to avoid FOUC (flash of unstyled content)
</style>

<style lang="scss" scoped>
.facets-list-pending {
  :deep(button.csg-horizontal-facet) {
    background-color: #f8f8f8;
    color: #626369;
    cursor: not-allowed;
    pointer-events: none;
  }
}
// Styles are moved to the critical section to avoid FOUC (flash of unstyled content)
</style>
